exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vg-header{ display: none !important;\n}\n", ""]);

// exports
